<script setup lang="ts">
import type { ProvenanceItem } from "../types";
defineProps<{ items: ProvenanceItem[] }>();
</script>
<template>
  <section class="section-block" aria-labelledby="provenance-title">
    <div class="section-heading">
      <div>
        <p class="eyebrow">Evidence</p>
        <h2 id="provenance-title">Provenance</h2>
      </div>
      <span class="count">{{ items.length }} claims</span>
    </div>
    <div v-if="items.length" class="provenance-list">
      <article v-for="item in items" :key="`${item.target_path}${item.source_revision}`">
        <span class="confidence" :data-level="item.confidence">{{ item.confidence }}</span>
        <div>
          <code>{{ item.target_path }}</code>
          <p>{{ item.locator_kind }} · {{ item.locator }}</p>
          <small>{{ item.extraction_method }} · {{ item.source_revision.slice(0, 18) }}…</small>
        </div>
      </article>
    </div>
    <p v-else class="empty">No provenance claims are indexed for this entity.</p>
  </section>
</template>
